import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {
  return (
    <footer style={{ backgroundColor: '#007bff', color: 'white', padding: '20px 0' }}>
      <Container>
        <Row>
          <Col md={12} className="text-center">
            <p>&copy; {new Date().getFullYear()} Manami Trading CC. All rights reserved.</p>
            <p>Windhoek, Namibia | info@manami-trading.com | +264 811 406 099</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
